module.exports = __webpack_public_path__ + "static/media/home-carousel5.70f4fd5b.webp";